<h1 class="line-background">
  <span>{{ "quem_somos" | translate }}</span>
</h1>
<br />
<div>
  <span>{{ "texto_quem_somos_1" | translate }}</span>
  <b><span>{{ "texto_quem_somos_2" | translate }}</span></b>
  <span>{{ "texto_quem_somos_3" | translate }}</span>
</div>